var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTyperightDown = function SvgTyperightDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.17 8.465 5.157 5.156v-3.95a.5.5 0 0 1 1 0v5.158a.5.5 0 0 1-.5.5H9.67a.5.5 0 0 1 0-1h3.95L8.463 9.172a.5.5 0 0 1 .707-.707Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.071 19.071c-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142Zm-.707-13.435A9 9 0 1 1 5.636 18.364 9 9 0 0 1 18.364 5.636Z",
    fill: "currentColor"
  })));
};
export { SvgTyperightDown as ReactComponent };
export default __webpack_public_path__ + "d5084f7ec063eac3d45cfd967fe09c5f.svg";